module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch0104#chapter01"
    }
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch0104#chapter02"
    }
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch0104#chapter03"
    }
  }, [_vm._v("THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch0104#chapter04"
    }
  }, [_vm._v("FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch0508#chapter05"
    }
  }, [_vm._v("FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch0508#chapter06"
    }
  }, [_vm._v("SIX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch0508#chapter07"
    }
  }, [_vm._v("SEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch0508#chapter08"
    }
  }, [_vm._v("EIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch0911#chapter09"
    }
  }, [_vm._v("NINE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch0911#chapter10"
    }
  }, [_vm._v("TEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch0911#chapter11"
    }
  }, [_vm._v("ELEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1214#chapter12"
    }
  }, [_vm._v("TWELVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1214#chapter13"
    }
  }, [_vm._v("THIRTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1214#chapter14"
    }
  }, [_vm._v("FOURTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIFTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1618#chapter16"
    }
  }, [_vm._v("SIXTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1618#chapter17"
    }
  }, [_vm._v("SEVENTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1618#chapter18"
    }
  }, [_vm._v("EIGHTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1920#chapter19"
    }
  }, [_vm._v("NINETEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1920#chapter20"
    }
  }, [_vm._v("TWENTY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWENTY-ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch2227#chapter22"
    }
  }, [_vm._v("TWENTY-TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch2227#chapter23"
    }
  }, [_vm._v("TWENTY-THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch2227#chapter24"
    }
  }, [_vm._v("TWENTY-FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch2227#chapter25"
    }
  }, [_vm._v("TWENTY-FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch2227#chapter26"
    }
  }, [_vm._v("TWENTY-SIX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch2227#chapter27"
    }
  }, [_vm._v("TWENTY-SEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch2834#chapter28"
    }
  }, [_vm._v("TWENTY-EIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch2834#chapter29"
    }
  }, [_vm._v("TWENTY-NINE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch2834#chapter30"
    }
  }, [_vm._v("THIRTY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch2834#chapter31"
    }
  }, [_vm._v("THIRTY-ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch2834#chapter32"
    }
  }, [_vm._v("THIRTY-TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch2834#chapter33"
    }
  }, [_vm._v("THIRTY-THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch2834#chapter34"
    }
  }, [_vm._v("THIRTY-FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/biography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biography of Brian Freemantle")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0